import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { NFLookupCashRegister } from "../../../../Shared/NewForms/NFLookupCashRegister";

const ExpenseCashsIssueToAnotherBankDetail = () => {
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation();
  const { watch } = useFormContext();

  const handleListChange = (selectedOption: number) => {
    if (selectedOption === 0) {
      setShowModal(true);
    } else if (selectedOption === 1) {
      setShowModal(false);
    }
  };
  return (
    <Row>
      <Col sm={6}>
        <NFLookupCashRegister fieldName="receiverCashRegisterId" title={t("ReceiverCashRegister")} required />
      </Col>
      {/* {showModal && (
        <NFormTable fieldArray={"payments"}>
          <NFLookupCurrency title={t("Currency")} fieldName="currencyId" width={500} />
          <NFIntInput title={t("Amount")} fieldName="amount" />
          <NFIntInput title={t("CurrencyAmount")} fieldName="currencyAmount" />
        </NFormTable>
      )} */}
    </Row>
  );
};

export default ExpenseCashsIssueToAnotherBankDetail;
